import styled, { css } from 'styled-components';
import {
  Button as StormButton,
  isMobileStyleMixin,
  MenuButtonTrigger,
  MenuItemGroup,
  MenuItemLink,
  styleMixinFocusOutline,
  TextButton as StormTextButton,
} from '@amzn/storm-ui';
import { DropdownAction } from '@amzn/storm-ui-page-header';

export const ActionDropdownTrigger = styled(MenuButtonTrigger)`
  ${isMobileStyleMixin(css`
    width: 100%;
  `)};

  & span {
    width: inherit;
  }
`;

export const Button = styled(StormButton)`
  ${isMobileStyleMixin(css`
    width: 100%;
  `)}
`;

export const TextButton = styled(StormTextButton)`
  ${isMobileStyleMixin(css`
    width: 100%;
  `)}
`;

export const StyledDropdownAction = styled(DropdownAction)`
  & li {
    list-style: none;
  }
`;

export const StyledMenuItemGroup = styled(MenuItemGroup)`
  & ul {
    margin: 0;
  }
`;

export const StyledMenuItemLink = styled(MenuItemLink)`
  :hover {
    text-decoration: none;
  }

  :focus {
    outline: none;
  }

  :focus-visible {
    ${styleMixinFocusOutline};
  }
`;
